'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');

module.exports = function () {
    $('.country-selectors a').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var action = $('.page').data('action');
        var localeCode = $(this).data('locale');
        var siteId = $(this).data('siteid');
        var localeCurrencyCode = $(this).data('currencycode');
        var queryString = $('.page').data('querystring');
        var url = $('.country-selectors').data('url');
        var urlTobeRedirected=$(this).data('urlss');
        
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {
                code: localeCode,
                queryString: queryString,
                CurrencyCode: localeCurrencyCode,
                action: action,
                siteId: siteId
            },
            success: function (response) {
                $.spinner().stop();
                window.location.href=urlTobeRedirected;
                // if (response && response.redirectUrl) {
                //     window.location.href = response.redirectUrl;
                // }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    keyboardAccessibility('.navbar-header .country-selectors',
        {
            40: function ($countryOptions) { // down
                if ($(this).is(':focus')) {
                    $countryOptions.first().focus();
                } else {
                    $(':focus').next().focus();
                }
            },
            38: function ($countryOptions) { // up
                if ($countryOptions.first().is(':focus') || $(this).is(':focus')) {
                    $(this).focus();
                    $(this).removeClass('show');
                } else {
                    $(':focus').prev().focus();
                }
            },
            27: function () { // escape
                $(this).focus();
                $(this).removeClass('show').children('.dropdown-menu').removeClass('show');
            },
            9: function () { // tab
                $(this).removeClass('show').children('.dropdown-menu').removeClass('show');
            }
        },
        function () {
            if (!($(this).hasClass('show'))) {
                $(this).addClass('show');
            }
            return $(this).find('.dropdown-country-selectors').children('a');
        }
    );

    $('.navbar-header .country-selectors').on('focusin', function () {
        $(this).addClass('show').children('.dropdown-menu').addClass('show');
    });

    var isDesktop = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    $('.countrySelectorOverlay').on('click', function () {
        $('.navbar-header .country-selectors').toggleClass('show');
        $('.navbar-header .country-selectors').find('.dropdown-menu.dropdown-country-selectors').toggleClass('show');
    });
};
